import React, { Component } from 'react';

import { Form, Select } from 'antd';

const FormItem = Form.Item;

class Number extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lessonNumBg: props.lessonNumBg,
            lessonNumEnd: props.lessonNumEnd,
        };
    }

    componentDidMount() {

    }

    handleChange(data) {
        const domain = Object.assign({}, this.state, data);
        this.setState(domain);

        if(this.props.handleChange) {
            this.props.handleChange(domain);
        }
    }

    range(start, stop) {
        var result = [];
        for (start; start <= stop; start++) {
            result.push(start);
        }

        return result;
    }

    componentWillReceiveProps(nextProps) {

        if(nextProps.hasOwnProperty('lessonNumBg')) {
            this.setState({
                lessonNumBg: nextProps.lessonNumBg
            });
        }

        if(nextProps.hasOwnProperty('lessonNumEnd')) {
            this.setState({
                lessonNumEnd: nextProps.lessonNumEnd
            });
        }
    }

    render() {
        const {style, disabled , name , rules , getFieldDecorator , label} = this.props;
        const {lessonNumBg, lessonNumEnd} = this.state;
        return (
            <FormItem label={label || "节次"}>
                {
                    getFieldDecorator ? (
                        getFieldDecorator(name+"Bg", {
                            initialValue: lessonNumBg,
                            rules: rules || [{
                                required: true,
                                message: '请选择'+label,
                            }],
                        })(
                            <Select
                            placeholder='请选择...'
                            allowClear={true}
                            disabled={disabled}
                            value={lessonNumBg}
                            style={style || {width: 80}}
                            onChange={(lessonNumBg) => {
                                this.handleChange({lessonNumBg});
                            }}
                            dropdownMatchSelectWidth={false}
        
                        >
                            {
                                this.range(1, 18).map(value => (
                                    <Option value={value}>{value}</Option>
                                ))
                            }
                        </Select>
                        )
                    ) : (
                        <Select
                        placeholder='请选择...'
                        allowClear={true}
                        disabled={disabled}
                        value={lessonNumBg}
                        style={style || {width: 80}}
                        onChange={(lessonNumBg) => {
                            this.handleChange({lessonNumBg});
                        }}
                        dropdownMatchSelectWidth={false}
                    >
                        {
                            this.range(1, 18).map(value => (
                                <Option value={value}>{value}</Option>
                            ))
                        }
                    </Select>
                    )
                }
                <span className="cut-off-rule">~</span>
                {
                     getFieldDecorator ? (
                        getFieldDecorator(name+"End", {
                            initialValue: lessonNumEnd,
                            rules: rules || [{
                                required: true,
                                message: '请选择'+label,
                            }],
                        })(
                            <Select
                                disabled={disabled}
                                allowClear={true}
                                placeholder='请选择...'
                                value={lessonNumEnd}
                                style={style || {width: 80}}
                                onChange={(lessonNumEnd) => {
                                    this.handleChange({lessonNumEnd});
                                }}
                                dropdownMatchSelectWidth={false}

                            >
                                {
                                    this.range(1, 18).map(value => (
                                        <Option value={value}>{value}</Option>
                                    ))
                                }
                            </Select>
                        )
                     ):(
                        <Select
                            disabled={disabled}
                            allowClear={true}
                            placeholder='请选择...'
                            value={lessonNumEnd}
                            style={style || {width: 80}}
                            onChange={(lessonNumEnd) => {
                                this.handleChange({lessonNumEnd});
                            }}
                            dropdownMatchSelectWidth={false}

                        >
                            {
                                this.range(1, 18).map(value => (
                                    <Option value={value}>{value}</Option>
                                ))
                            }
                        </Select>
                     )
                }
            </FormItem>
        );
    }
}

export default Number;